import createFetchOptions from 'owa-service/lib/createFetchOptions';

export function createRestApiRequestHeadersWithFetchOptions() {
    // Create collection of headers, and initialize it with headers from fetchOptions.
    const fetchOptions = createFetchOptions();
    const headers: { [headerName: string]: string } = {};

    // Prior to Firefox v50, Firefox does not support headers.forEach.
    const fetchHeaders = new Headers(fetchOptions.headers);
    if (typeof fetchHeaders.forEach === 'function') {
        fetchHeaders.forEach((val, key) => {
            headers[key] = val;
        });
    } else {
        const iter = fetchHeaders.entries();
        var item = iter.next();
        while (!item.done) {
            const [key, value] = item.value;
            headers[key] = value;
            item = iter.next();
        }
    }

    // Add custom headers for CalendarsInternal behavior
    headers['prefer'] = 'exchange.Behavior="CalendarInternal"';

    return headers;
}
